import useRequest from '@/websdk/utils/request';
import { useEffect } from 'react';
export default (function (param) {
  const { exec, isRequestSuccessed } = useRequest({
    url: '',
    name: 'ONLINE_CRAFT_PUT',
    method: 'PUT',
  });
  useEffect(() => {
    if (param) {
      exec({ url: `/api/online-crafts/${param.craft_cid}`, data: param });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [param]);
  return [isRequestSuccessed, exec];
});
